import { UI } from '../action-types'

export const setIsUiModalOpen = (modalName: string, status: boolean) => ({
  type: UI.SET_IS_MODAL_OPEN,
  payload: {
    name: modalName,
    status,
  },
})
